import { jsx as o } from "react/jsx-runtime";
import { forwardRef as u } from "react";
import { useTextContext as x, TextProvider as T } from "../../../context/Text.js";
import { TypographyProvider as S } from "../../../context/Typography.js";
import { getToneContentColorRole as v } from "../../../styles/colors/content/getToneContentColorRole.js";
import { typographyBodySizeMap as B, typographyBodyLineHeightMap as w } from "../../../styles/typography/typography.js";
import "../../layout/Stack/Stack.js";
import C from "../../layout/Box/Box.js";
import "styled-components";
import "../../../index-CZ8zjHGv.js";
import "../../layout/Center/Center.js";
import "../../../context/WindowSize/Dimensions.js";
import "lodash-es";
import "../../layout/Columns/ColumnsContext.js";
import { capitalizeStyles as M, uppercaseStyles as b, truncateStyles as z } from "../consts.js";
import { useThemeInMode as P } from "../../../context/theme/hooks.js";
const Q = u(
  ({
    children: e,
    tone: p = "neutral",
    emphasis: m = "high",
    onHighEmphasisSurface: n = !1,
    weight: i = "normal",
    size: r = "medium",
    lineHeight: t = "small",
    display: a = "block",
    align: l,
    truncate: f = !1,
    uppercase: s = !1,
    capitalize: y = !1,
    dataNoTranslate: c,
    dataTest: h
  }, d) => {
    if (x())
      throw new Error(
        "Text component cannot be a child of Typography components"
      );
    const g = P()[v({
      tone: p,
      emphasis: m,
      onHighEmphasisSurface: n
    })];
    return /* @__PURE__ */ o(T, { value: !0, children: /* @__PURE__ */ o(S, { value: { typographyBodySize: r, lineHeight: t }, children: /* @__PURE__ */ o(
      C,
      {
        ref: d,
        component: "span",
        display: a,
        ...B[r],
        ...w[t],
        fontWeight: i,
        textAlign: l,
        margin: "none",
        padding: "none",
        color: g,
        dataNoTranslate: c,
        dataTest: h,
        ...y && M,
        ...s && b,
        ...f && z,
        children: e
      }
    ) }) });
  }
);
export {
  Q as default
};
